import { FieldValues, Path, UseFormSetError } from 'react-hook-form';

type BackendFieldError = {
	rule?: string;
	field?: string;
	message?: string;
};

/**
 * Maps backend (Adonis validator) field errors from a failed request onto
 * react-hook-form fields, so the offending inputs turn red with their
 * messages. The backend sends `{ errors: [{ rule, field, message }] }` on 422,
 * where `field` is the dotted payload path (e.g. "instructor.label") matching
 * the RHF field name.
 *
 * Returns true if at least one field error was applied (use it to pick a
 * "fix the highlighted fields" snackbar over the raw backend message).
 */
export function applyBackendErrors<T extends FieldValues>(
	error: any,
	setError: UseFormSetError<T>
): boolean {
	const errors: BackendFieldError[] | undefined = error?.response?.data?.errors;
	if (!Array.isArray(errors)) return false;
	let applied = false;
	for (const err of errors) {
		if (!err?.field) continue;
		setError(err.field as Path<T>, {
			type: 'server',
			message: err.message || 'Invalid value',
		});
		applied = true;
	}
	return applied;
}
